export interface Payment {
    codigo: string;
    descripcionCorta: string;
    descripcionLarga: string;
    icono: string;
    nombre: string;
    orden: string;
    pasarela: string;
}


/**
 * Payment
 *
 * @export
 * @class Payment
 */
export class PaymentHelper {

    static create(): Payment {
        return {
            codigo: '',
            descripcionCorta: '',
            descripcionLarga: '',
            icono: '',
            nombre: '',
            orden: '',
            pasarela: ''
        };
    }

    /**
     * Transform json into payment
     *
     * @static
     * @param {Object} obj
     * @returns {Payment}
     *
     * @memberOf Payment
     */
    static transformFromApi(obj: Object) {
        const payment = PaymentHelper.create();
        payment.codigo = obj['FO_CODIGO'] ? obj['FO_CODIGO'] : '';
        payment.descripcionCorta = obj['FO_DESCRIPCIONCORTA'] ? obj['FO_DESCRIPCIONCORTA'] : '';
        payment.descripcionLarga = obj['FO_DESCRIPCIONLARGA'] ? obj['FO_DESCRIPCIONLARGA'] : '';
        payment.icono = obj['FO_ICONO'] ? obj['FO_ICONO'] : '';
        payment.nombre = obj['FO_NOMBRE'] ? obj['FO_NOMBRE'] : '';
        payment.orden = obj['FO_ORDEN'] ? obj['FO_ORDEN'] : '';
        payment.pasarela = obj['FO_PASARELA'] ? obj['FO_PASARELA'] : '';
        return payment;
    }
}
